import React, { memo, useState, useCallback } from "react";
import { PDPContext } from ".";

const PDPManager = memo(({ children }) => {
	const [PDPInfo, setPDPInfo] = useState(false);
	const [PDPCache, setPDPCache] = useState({});
	const [hoveringPDP, setHoveringPDP] = useState(false);
	const [targetProductsScrolling, setTargetProductsScrolling] =
		useState(false);
	const [hoveringProduct, setHoveringProduct] = useState(false);

	const handlePDPInfo = useCallback((callback) => {
		if (typeof callback === "function") {
			return setPDPInfo((PDPInfo) => callback(PDPInfo));
		}
		return setPDPInfo(callback);
	}, []);

	const handlePDPHover = useCallback((callback) => {
		if (typeof callback === "function") {
			return setHoveringPDP((hoveringPDP) => callback(hoveringPDP));
		}
		return setHoveringPDP(callback);
	}, []);

	const handleProductHover = useCallback((callback) => {
		if (typeof callback === "function") {
			return setHoveringProduct((hoveringPDP) => callback(hoveringPDP));
		}
		return setHoveringProduct(callback);
	}, []);

	const handleTargetProductsScrolling = useCallback((callback) => {
		if (typeof callback === "function") {
			return setTargetProductsScrolling((hoveringPDP) =>
				callback(hoveringPDP)
			);
		}
		return setTargetProductsScrolling(callback);
	}, []);

	return (
		<PDPContext.Provider
			value={{
				PDPInfo,
				setPDPInfo: handlePDPInfo,
				PDPCache,
				setPDPCache,
				hoveringPDP,
				setHoveringPDP: handlePDPHover,
				hoveringProduct,
				setHoveringProduct: handleProductHover,
				targetProductsScrolling,
				setTargetProductsScrolling: handleTargetProductsScrolling,
			}}
		>
			{children}
		</PDPContext.Provider>
	);
});

export default PDPManager;
